import { useParams } from 'react-router-dom'
import { getEventTypes, getEvents } from '../api/reader-api'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { useEffect, useState } from 'react'
import { EventsResponse } from 'models/EventsResponse'

type ReaderEvent = {
  login: string
  serial: number
  date: string
  time: string
  timestamp: number
  type: number
  typeName: string
  metaInfo?: string
}

const getEventsData = async (
  id?: string,
  date?: string
): Promise<EventsResponse[]> => {
  if (!id) {
    throw new Error('Invalid id')
  }

  const eventsDate = new Date(date as string)
  if (Number.isNaN(eventsDate.getTime())) {
    throw new Error('Invalid date')
  }

  return getEvents(id, eventsDate)
}

const ReaderEvents = () => {
  const params = useParams()
  const [events, setEvents] = useState<string>('')

  const {
    isError: eventsIsError,
    data: eventData,
    error: eventsError,
  } = useQuery({
    queryKey: ['events', params.id, params.date],
    queryFn: () => getEventsData(params.id, params.date),
  })

  const {
    isError: eventTypesIsError,
    data: eventTypesData,
    error: eventTypesError,
  } = useQuery({
    queryKey: ['event_types'],
    queryFn: () => getEventTypes(),
  })

  useEffect(() => {
    if (eventsIsError && eventsError instanceof Error) {
      toast.error(eventsError.message)
    }
  }, [eventsIsError, eventsError])

  useEffect(() => {
    if (eventTypesIsError && eventTypesError instanceof Error) {
      toast.error(eventTypesError.message)
    }
  }, [eventTypesIsError, eventTypesError])

  useEffect(() => {
    if (eventData && eventTypesData) {
      const eventTypesMap = new Map<number, string>()
      eventTypesData.forEach((eventType) => {
        eventTypesMap.set(
          eventType.id,
          eventType.description || eventType.id.toString()
        )
      })

      const events: ReaderEvent[] = []

      for (let i = 0; i < eventData.length; i++) {
        const eventsResponse = eventData[i]
        if (eventsResponse.reader_id !== params.id) {
          continue
        }

        for (let j = 0; j < eventsResponse.events.length; j++) {
          const eventResponse = eventsResponse.events[j]
          const event: ReaderEvent = {
            login: eventsResponse.login,
            serial: eventsResponse.serial,
            date: eventsResponse.date,
            time: eventResponse.time,
            timestamp: Date.parse(
              `${eventsResponse.date}T${eventResponse.time}Z`
            ),
            type: eventResponse.type,
            typeName:
              eventTypesMap.get(eventResponse.type) ||
              eventResponse.type.toString(),
            metaInfo: eventResponse.mi || '',
          }
          events.push(event)
        }
      }

      if (events.length === 0) {
        setEvents('')
        return
      }

      events.sort((a, b) => a.timestamp - b.timestamp)

      const buffer: string[] = []
      buffer.push('Login;Serial;Date;Time;Type;TypeName;MetaInfo;')

      events.forEach((event) => {
        buffer.push(
          `${event.login};${event.serial};${event.date};${event.time};${event.type};${event.typeName};${event.metaInfo};`
        )
      })

      setEvents(buffer.join('\n'))
    }
  }, [params.id, eventData, eventTypesData])

  return <pre className='text-xs break-normal'>{events}</pre>
}

export default ReaderEvents
